import { auth, firebase } from '../firebase';


export const doSignIn=(email, password)=>{
	return new Promise((resolve,reject)=>{

		auth.doSignIn(email, password)
	      .then((x) => {

	      	const lockedRef = firebase.db.ref(x.uid+'/locked');
				lockedRef.once('value',(snap)=>{
					// if(!!snap.val()){
					// 	auth.doSignOut();
					// 	reject({message:'LOGGED IN ON ANOTHER DEVICE'})
					// } else {
					// 	lockedRef.set(true);
					// 	resolve(x);
					// }
					resolve(x);
				})
	      	
	      	})
	      .catch(error => {
	        reject(error);
	      });

	})
}

export const doSignOut=()=>{
	firebase.db.ref(auth.currentUser().uid+'/locked').set(false);
	auth.doSignOut();	
}






// WEBPACK FOOTER //
// ./src/session/index.js